const InStkWth = "IncreaseStrokeWidth";
const DecStkWth = "DecreaseStrokeWidth";
const ChangeColor = "ChangeColor";
const InSheets = "IncreaseSheet";
const EraserModeOn = "EraserModeOn";
const EraserModeOff = "EraserModeOff";

export {
  InStkWth,
  DecStkWth,
  ChangeColor,
  InSheets,
  EraserModeOn,
  EraserModeOff,
};
